<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#smartphone-s"></use></svg>
  <ng-container>OK-app onboarding invitationer</ng-container>
</h2>
<button type="button" class="btn-close btn-icon" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content>
  @if (appInvitationsFilterModel) {
    <div [formGroup]="appInvitationsFilterModel">
      <div class="form-row form-row--inline margin--right-m">
        <mat-form-field class="actions__query">
          <mat-label>Søg brugere</mat-label>
          <input matInput placeholder="e-mail, tlf, org. mm." formControlName="query" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
      <div class="form-row form-row--inline">
        <mat-form-field class="actions__status">
          <mat-label>Vælg status</mat-label>
          <mat-select #statusSelect formControlName="selectedAppInvitationStatus" okCustomDropDownArrowDirective>
            <mat-option [value]="null">Alle</mat-option>
            @for (status of statuses | enumToArray | translateAppInvitationStatusEnum; track status) {
              <mat-option [value]="status.index">
                {{ status.name }}
              </mat-option>
            }
          </mat-select>
          @if (appInvitationsFilterModel.get('selectedAppInvitationStatus')?.value !== null) {
            <button
              matSuffix
              class="clear-input-field-button"
              type="button"
              (click)="clearSearch(); $event.stopPropagation()"
              aria-label="Ryd indhold i feltet">
              <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#close-s"></use></svg>
            </button>
          }
          <mat-icon matSuffix></mat-icon>
        </mat-form-field>
      </div>
    </div>
  }
  <adm-loading-spinner [loading$]="loading$"></adm-loading-spinner>

  <table
    #appInvitationList
    mat-table
    [dataSource]="data$"
    [class.loading-blur]="loading$ | async"
    [class.loading-blur--done]="(loading$ | async) === false"
    class="invitation-table"
    matSort
    (matSortChange)="sortData($event)">
    <ng-container matColumnDef="chargingUsersName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Navn</th>
      <td mat-cell *matCellDef="let invitation" class="row">
        {{ invitation.chargingUsersName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="phoneNumber">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="phoneNumber" class="col">Mobilnummer</th>
      <td mat-cell *matCellDef="let invitation" class="row">
        {{ invitation.phoneNumber }}
      </td>
    </ng-container>
    <ng-container matColumnDef="organizationName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="organizationName" class="col">Organisation</th>
      <td mat-cell *matCellDef="let invitation" class="row">
        {{ invitation.organizationName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="appInvitationStatus">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Status</th>
      <td mat-cell *matCellDef="let invitation" class="row">
        {{ invitation.appInvitationStatus | translateAppInvitationStatusEnum }}
      </td>
    </ng-container>
    <ng-container matColumnDef="deepLinkCreated">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="col">Deeplink oprettet</th>
      <td
        mat-cell
        *matCellDef="let invitation"
        class="row"
        title="{{ invitation.deepLinkCreated | date: 'dd.MM.yyyy HH:mm:ss' }}"
        (click)="consoleLogDeepLink(invitation)">
        {{ invitation.deepLinkCreated | date: 'short' }}
      </td>
    </ng-container>
    <ng-container matColumnDef="smsSent">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="col text-center">Sms sendt</th>
      <td mat-cell *matCellDef="let invitation" class="row text-center">
        @if (invitation.appInvitationStatus === statuses.Queued) {
          <mat-icon [matTooltip]="invitation.executionDate | date: 'dd.MM.yyyy HH:mm:ss'">schedule</mat-icon>
        } @else {
          {{ invitation.smsSent | date: 'short' }}
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef class="col align-right"></th>
      <td mat-cell *matCellDef="let invitation" class="row align-right">
        <button mat-icon-button [matMenuTriggerFor]="contextMenu" aria-label="Handlinger">
          <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu #contextMenu="matMenu">
          <button mat-menu-item (click)="gotoSend(invitation)">
            <mat-icon class="outlined">send_to_mobile</mat-icon>
            <span>Vis invitations historik</span>
          </button>
        </mat-menu>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
    <tr mat-row *matRowDef="let rowData; columns: displayColumns" [class.highlight]="rowData.highlight | async"></tr>
  </table>

  <mat-paginator
    #paginator
    [style.visibility]="appInvitationsCount ? 'visible' : 'hidden'"
    [pageIndex]="currentPage"
    [pageSize]="pagingOptions.pageSize"
    [length]="appInvitationsCount"
    [pageSizeOptions]="pagingOptions.pageSizeOptions"
    (page)="onPageChanged($event)"
    color="accent"
    [disabled]="(loading$ | async) === true" />
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" mat-button (click)="close()">Luk</button>
</mat-dialog-actions>
